module.exports = __webpack_public_path__ + "static/media/no-feedback.870ae400.svg";